import { MyHistory } from "components/partial/myDesk/my-history/my-history";
import { useRouteUserId } from "hooks/useRouteUserId";
import MyAccountLayout from "layouts/my-account/my-account-layout";
import ProfileLayout from "layouts/private/profile/profile-layout";

const MyHistoryPage = () => {
	const { routeUserId } = useRouteUserId();
	return routeUserId ? (
		<ProfileLayout>
			<MyHistory/>
		</ProfileLayout>
	) : (
		<MyAccountLayout>
			<MyHistory/>
		</MyAccountLayout>
	);
};

export default MyHistoryPage;
